import { type FC } from "react";
import { history } from "../../_Bootstrap/RoutingAndStore";
import PrimaryButton from "../../Common/Buttons/PrimaryButton";
import RetryButton from "../../Common/Buttons/RetryButton";
import NiceError from "../../Common/Errors/NiceError";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";

export const RenderNetworkError: FC<{
    onClear: () => void;
}> = ({ onClear }) => {
    return (
        <div id="shopfront-error">
            <NiceError
                actions={[
                    <RetryButton onClick={() => window.location.reload()} key="retry-button" />,
                    <PrimaryButton
                        key="return-to-sell"
                        onClick={() => {
                            history.push("/");
                            onClear();
                        }}
                    >
                        <FontAwesomeLight icon="cash-register" /> Return to Sell Screen
                    </PrimaryButton>,
                ]}
            >
                <p>
                    We encountered a network error while loading the page (and the page doesn&apos;t exist in your
                    cache).
                </p>
                <p>
                    Once you have access to the internet again, you can refresh the page and try again, otherwise you
                    might want to return to the sell screen.
                </p>
            </NiceError>
        </div>
    );
};
